import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import useInvoiceScanManager from 'src/hooks/useInvoiceScanManager';

const UploadedByCell = (props: GridCellProps) => {
  const { handleCellClick } = useInvoiceScanManager();
  const handleClick = useCallback(() => {
    handleCellClick(props.dataItem.attachId);
  }, [handleCellClick, props.dataItem.attachId]);

  const value = props.dataItem[props.field || ''] 
  
  return (
    <GridCellBase {...props} rowSelectionEnabled={false} onClick={handleClick} title={value}>
      {value}
    </GridCellBase>
  );
};

export default UploadedByCell;
